import React from 'react';
import PropTypes from 'prop-types';
import { Map } from 'immutable';

import { ButtonWithIcon } from '@els/els-react--button';

export default function ThesaurusExpandButton({ item, isOpen, isFolder, onToggleGroup }) {
  if (!isFolder) {
    return null;
  }

  return (
    <ButtonWithIcon
      type="link"
      size="small"
      sprite={isOpen ? 'ChevronDown' : 'ChevronRight'}
      iconOnly
      onClick={() => onToggleGroup(item)}
      className="e2e-thesaurus-expand"
      aria-label="Expand">
      Expand
    </ButtonWithIcon>
  );
}

ThesaurusExpandButton.propTypes = {
  item: PropTypes.instanceOf(Map).isRequired,
  isOpen: PropTypes.bool.isRequired,
  isFolder: PropTypes.bool.isRequired,
  onToggleGroup: PropTypes.func.isRequired,
};
